import ContactForm from "components/contact-us/ContactForm"
import { GetStaticProps } from "next"
import Head from "next/head"

const ContactUsForm = () => {
  return (
    <>
      <Head>
        <meta httpEquiv="Content-type" content="text/html; charset=UTF-8" />
      </Head>
      <ContactForm />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default,
    },
    revalidate: 60,
  }
}

export default ContactUsForm
